
                                var button = document.querySelector('.btn-product-show-more'); 
                                var box = document.querySelectorAll(".boxes");
                                var btn = document.querySelectorAll("#myBtn");
                                var modal = document.querySelector("#myModal");
                                var spans = document.querySelectorAll('.close');

                                for (let i = 0; i < btn.length; i++) {
                                   btn[i].onclick = function() {
                                     modal.classList.remove('popup_save');
                                      modal.classList.add('popup_save_new');
                                      
                                    }
                                    
                                  for(let k = 0; k < spans.length; k++){
                                  spans[k].addEventListener('click',function(){
                                        modal.classList.remove('popup_save_new');
                                        modal.classList.add('popup_save');
                                });
                                  }
                                                                  
                                  window.addEventListener('click', function(event) {
                                    for (let j = 0; j < btn.length; j++) {
                                      if (event.target == modal) {
                                        modal.classList.remove('popup_save_new');
                                        modal.classList.add('popup_save');
                                      }

                                    }
                                  });
                        
                              }
